// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"24":"18f820fd","367":"6191a611","494":"74a92d1a","583":"88cfe000","984":"18f820fd"}[chunkId] + ".css";
};